import React, { useEffect, useMemo, useState } from 'react';
import Search from 'components/Search';
import { Container } from 'components/Container';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSearchContext } from 'Contexts/SearchContext';
import { Breadcrumbs } from 'components/Breadcrumbs';
import BackToLink from 'shared-components/BackToLink';
import { Box } from '@mui/material';
import { generateContainerStyles } from 'components/Container/ContainerStyles';
import { useTheme } from '@emotion/react';
import { generateHeaderStyles } from 'sections/Header/HeaderStyles';

export function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const [isFixedShown, setFixedShown] = useState(false);
    const { searchInput, setSearchInput } = useSearchContext();
    const containerStyles = useMemo(() => generateContainerStyles(), []);
    const theme = useTheme();
    const styles = useMemo(() => generateHeaderStyles(theme), [theme]);

    const handleScroll = () => {
        if (window.scrollY > 280) {
            setFixedShown(true);
        } else {
            setFixedShown(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (searchInput === null) return;
        if (searchInput?.length === 0) {
            return navigate('/');
        }

        if (searchInput?.length >= 3) navigate(`/search?query=${searchInput}`);
    }, [searchInput]);

    return (
        <>
            <Box component="header" sx={styles.header}>
                <Box>
                    <Box component="h3" sx={styles.subTitle}>Knowledge Base</Box>
                    <Box component="h2" sx={styles.title}>How can we help?</Box>
                    <Search searchInput={searchInput || ''} setSearchInput={setSearchInput} />
                </Box>
            </Box>

            {isFixedShown && (
                <Box
                    component="header" sx={{
                        ...styles.header,
                        ...styles.headerFixed,
                    }}
                >
                    <Container>
                        <Box component="h3" sx={{ ...styles.subTitle, marginBottom: '16px' }}>Knowledge Base</Box>
                        <Search searchInput={searchInput || ''} setSearchInput={setSearchInput} />
                    </Container>
                    {location.pathname !== '/' && (
                        <Box sx={{ ...containerStyles.container, ...styles.breadcrumbsWrapper }}>
                            <Breadcrumbs sx={styles.breadcrumbs} />
                            <BackToLink />
                        </Box>
                    )}
                </Box>
            )}
        </>
    );
}
